import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './css/breadcrumb.css';
import { Store } from '../../Store';

const Breadcrumb = () => {
  const { state } = useContext(Store);
  const { resentBread } = state;
  return (
    <section className="reBreadcrumb">
      <div className="container">
        <div className="row content-breadcrumb">
          <div className="col-12">
            <div className="d-flex icon align-items-center">
              <i className="fas fa-home" style={{ fontSize: '20px' }}></i>

              <div className="d-flex align-items-center ">
                <Link className="link-breadcrumb" to="/" title="Trang chủ">
                  Trang chủ
                </Link>
                {resentBread &&
                  resentBread.map(
                    (breadcrumb, idx) =>
                      breadcrumb.title && (
                        <React.Fragment key={idx}>
                          <span className="px-1">/</span>
                          <Link
                            className="link-breadcrumb"
                            to={breadcrumb.slug || '#'}
                            title={breadcrumb.title}
                          >
                            {breadcrumb.title}
                          </Link>
                        </React.Fragment>
                      )
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Breadcrumb;
